export enum EnvironmentEnum {
  LOCAL = 'local',
  DEVELOPMENT = 'development',
  STAG = 'stag',
  PROD = 'prod',
}

export enum RolesEnum {
  ADMIN = 'ADMIN',
}

export enum StorageEnum {
  ACCESS_TOKEN = 'access_token',
  REFRESH_TOKEN = 'refresh_token',
  SELECTED_USER = 'selected_user',
  STATUS_LOGIN = 'statusLogin',
}

export enum LanguageEnum {
  VI = 'vi',
  EN = 'en',
}

export enum ButtonTypeEnum {
  PRIMARY = 'primary',
  DANGER = 'danger',
}

export enum AlertTypeEnum {
  REMOVE_DEVICE = 1,
  GEOFENCE = 2,
  GATHERING = 3,
  OFFLINE = 4,
}

export enum AlertLevelEnum {
  WARNING = 2,
  CRITICAL = 3,
}

export enum AlertStatusEnum {
  PROCESSED = 2,
  UNPROCESSED = 1,
}

export enum GenderEnum {
  FEMALE = 2,
  MALE = 1,
}

export enum ImeiEnum {
  ASSIGNED = 1,
  UNASSIGNED = 0,
}

export enum ActiveEnum {
  BLOCKED = 0,
  OPEN = 1,
}

export enum TypeAlertEnum {
  ACTION_LOG = 'action_log',
  ALERT = 'alert',
}

export enum RoleIdUserEnum {
  QUAN_TRI = 1,
  TINH_THANH = 3,
  XA_PHUONG = 4,
  NGUOI_DEO = 6,
  TRUNG_UONG = 11,
}

export enum SortDirectionEnum {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum StatusEnum {
  ACTIVE = 1,
  INACTIVE = 0,
}

export enum TypeEnum {
  TAI_KHOAN = 1,
  HO_SO = 2,
  THIET_BI = 3,
  HANG_RAO = 4,
  CANH_BAO = 5,
}

export enum LocationTypeEnum {
  VAO = 1,
  RA = 2,
  VAO_RA = 3,
}

export enum AreaStatsEnum {
  ALERT = 'alert',
  PERSON = 'person',
}

export enum NewPersonStatsEnum {
  MONTH = 'month',
  PROVINCE = 'province',
}
